import moment from 'moment'

angular.module('webtrader').component('pendingOrder', {
  bindings: {
    collapsed: '=',
  },
  templateUrl: BASE_URL+'templates/component.pendingOrder.html',
  controller: function (Quotes, Trades) {
    this.quotes = Quotes

    this.volume = 0.1
    if (Quotes.currentQuote) {
      this.price = Quotes.currentQuote.bid
    } else {
      this.price = 0
    }
    this.sl = 0
    this.tp = 0
    this.cmd = 2

    this.cmds = [{
      label: "BUY LIMIT", cmd: 2
    }, {
      label: "SELL LIMIT", cmd: 3
    }, {
      label: "BUY STOP", cmd: 4
    }, {
      label: "SELL STOP", cmd: 5
    }]

    let e = moment().add(1, 'day')
    this.eDay = e.day()
    this.eMonth = e.month()
    this.eYear = e.year()
    this.eHour = e.hour()
    this.eMinute = e.minute()

    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))

    this.openTrade = () => {
      Trades.order({
        order_type: 'deferred',
        cmd: this.cmd,
        symbol: Quotes.currentSymbol,
        volume: this.volume,
        sl: this.sl,
        tp: this.tp,
        open_price: this.price,
        expiration: this.editExpiration? moment({
          year: this.eYear,
          month: this.eMonth,
          day: this.eDay,
          hour: this.eHour,
          minute: this.eMinute
        }).toDate() : null
      })
    }
  }
})
